import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from '@/components/AppRoutes'
import { ErrorBoundary } from '@/components/ui/ErrorBoundary'
import { NutritionDataProvider } from '@/components/NutritionDataProvider'

function App() {
  return (
    <ErrorBoundary showRetry={false}>
      <NutritionDataProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </NutritionDataProvider>
    </ErrorBoundary>
  )
}

export default App
export { App }
